<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    width="60%"
    class="edit-detail-dialog"
    center
    @close="handleDialogClose"
    :close-on-click-modal="false">
    <span slot="title" class="title-container">
      <span class="title-text">{{isEdit ? $t('incomeStorage.editCase') : $t('incomeStorage.addCase')}}</span>
      <img
        src="@/assets/close.png"
        class="close-image"
        @click="close"
      />
    </span>
    <el-form class="el-form"  :model="form" ref="refForm" :rules="rules" label-width="80px">
      <el-form-item style="background: #F8F8F8; margin: 20px;" v-for="(item, index) in form.cases" :key="index" label-width="0">
        <el-col :span="9">
          <el-form-item :label="$t('common.caseNo') + ':'" :prop="'cases.' + index + '.trackingNo'" :rules="rules.caseNo">
            <el-input
              :disabled="isEdit"
              v-model.trim="item.trackingNo"
              name="caseNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item :label="$t('common.count') + ':'" :prop="'cases.' + index + '.count'" :rules="rules.count">
            <el-input
              v-model.trim.number="item.count"
              name="count"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="10"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="!isEdit" :span="5" style="text-align: center;">
          <el-form-item>
            <el-button
              v-if="form.cases.length > 1"
              size="small"
              type="text"
              @click="deleteCase(index)">
              {{$t('common.delete')}}
            </el-button>
            <el-button
              size="small"
              type="text"
              @click="addCase">
              {{$t('common.add')}}
            </el-button>
          </el-form-item>
        </el-col>
      </el-form-item>
    </el-form>
    <span slot="footer">
        <el-button size="small" @click="close">{{$t('common.back')}}</el-button>
        <el-button
          :loading="loading"
          size="small"
          type="primary"
          @click="save">
            {{$t('common.save')}}
        </el-button>
      </span>
  </el-dialog>
</template>

<script>
import {
  incoStorageAddCase,
  incoStorageUpdateCase,
} from '@/api/incoStorage';
import {
  validateBoxNo,
  validateLotNo,
  validateCaseNo,
  validateCount,
} from '@/utils/validate';
import { isPositiveIntegerNum } from '@/utils';

export default {
  name: 'EditDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    editRow: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
      rules: {
        caseNo: [{ required: true, trigger: 'blur', validator: validateCaseNo }],
        count: [{ required: true, trigger: 'blur', validator: validateCount }],
      },
      loading: false,
    };
  },
  watch: {
    editRow(newVal) {
      this.form = Object.assign({}, newVal);
    },
  },
  methods: {
    handleDialogClose() {
      this.close();
    },
    close() {
      this.$emit('update:visible', false);
      this.$emit('close');
      if (this.$refs.refForm && typeof this.$refs.refForm.clearValidate === 'function') {
        this.$refs.refForm.clearValidate();
      }
    },
    deleteCase(index) {
      this.form.cases.splice(index, 1);
    },
    addCase() {
      this.form.cases.push({
        count: '',
        trackingNo: '',
      });
    },
    save() {
      this.$refs.refForm.validate((valid) => {
        if (valid) {
          if (this.isEdit) {
            this.incoStorageUpdateCase();
          } else {
            this.incoStorageAddCase();
          }
        } else {
          console.log('error submit!!');
        }
      });
    },
    async incoStorageUpdateCase() {
      const {
        cases
      } = this.form;
      let trackingNo, count;
      if (cases && cases.length > 0) {
        trackingNo = cases[0].trackingNo;
        count = cases[0].count;
      }
      this.loading = true;
      try {
        await incoStorageUpdateCase({
          trackingNo,
          count,
        });
        this.$message({
          type: 'success',
          message: this.$t('incomeStorage.updateSuccess'),
        });
        this.close();
      } catch (e) {
        // do nothing.
      } finally {
        this.loading = false;
      }
    },
    async incoStorageAddCase() {
      const {
        boxNo,
        cases,
      } = this.form;
      this.loading = true;
      try {
        await incoStorageAddCase({
          boxNo,
          cases,
        });
        this.$message({
          type: 'success',
          message: this.$t('incomeStorage.addSuccess'),
        });
        this.close();
      } catch (e) {
        // do nothing.
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
  .title-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: space-between;
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
    padding: 10px 15px;
    align-items: center;
  }
  .title-text {
    color: #404040;
    font-size: 16px;
  }
  .el-form {
    margin: 0 30px;
  }
  .close-image {
    width: 22px;
    height: 22px;
    cursor: pointer;
    padding: 0 10px;
  }
  .small-title {
    font-size: 14px;
    color: #606266;
    line-height: 40px;
  }
</style>
<style>
  .edit-detail-dialog .el-dialog__header {
    padding: 0;
  }
</style>
